import { render, staticRenderFns } from "./ShowVote.vue?vue&type=template&id=65aede44&scoped=true&"
import script from "./ShowVote.vue?vue&type=script&lang=js&"
export * from "./ShowVote.vue?vue&type=script&lang=js&"
import style0 from "./ShowVote.vue?vue&type=style&index=0&id=65aede44&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65aede44",
  null
  
)

export default component.exports